module.exports = __webpack_public_path__ + "static/media/footer-logo.9607e890.svg";